import React from 'react'
import { FormNewFolderFragment } from './form-new-folder-fragment'
import { Modal } from '@tecsinapse/cortex-react'
import { useConcederAcessoDialog } from '../hooks/use-conceder-acesso-dialog'
import { FormProvider } from 'react-hook-form'
import { Trans } from '@lingui/react/macro'
import { BibliotecaDialogProps } from '../types/types'

export const ConcederAcessoDialog = ({
  open,
  close,
  pastaAtual
}: BibliotecaDialogProps) => {
  const { form, onSubmit, closeForm } = useConcederAcessoDialog({
    pastaAtual,
    close
  })

  const { handleSubmit } = form

  return (
    <FormProvider {...form}>
      <Modal onClose={closeForm} open={open}>
        <div className={'w-[25rem] flex flex-col items-start'}>
          <p className={'text-h3 font-bold mb-deca'}>
            <Trans>Conceder Acesso</Trans>
          </p>
          <form onSubmit={handleSubmit(onSubmit)} className={'w-full'}>
            <div>
              <FormNewFolderFragment
                showPermissions
                submitLabel={'Conceder'}
                closeForm={closeForm}
              />
            </div>
          </form>
        </div>
      </Modal>
    </FormProvider>
  )
}
